export function mulberry32(seed) {
  let value = seed >>> 0;
  return () => {
    value += 0x6d2b79f5;
    let t = value;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

export function lerp(a, b, amount) {
  return a + (b - a) * amount;
}

export function fitCanvas(canvas, quality = "auto") {
  const rect = canvas.getBoundingClientRect();
  const cap = quality === "eco" ? 1 : quality === "high" ? 2 : 1.5;
  const dpr = Math.min(window.devicePixelRatio || 1, cap);
  const width = Math.max(1, Math.round(rect.width * dpr));
  const height = Math.max(1, Math.round(rect.height * dpr));
  if (canvas.width !== width || canvas.height !== height) {
    canvas.width = width;
    canvas.height = height;
  }
  const context = canvas.getContext("2d");
  context.setTransform(dpr, 0, 0, dpr, 0, 0);
  return { ctx: context, width: rect.width, height: rect.height, dpr };
}

export function pointerTracker(element) {
  const point = { x: 0.5, y: 0.5, active: false, down: false, speed: 0 };
  let lastX = 0;
  let lastY = 0;
  let lastTime = performance.now();
  const update = (event) => {
    const rect = element.getBoundingClientRect();
    const x = clamp((event.clientX - rect.left) / rect.width, 0, 1);
    const y = clamp((event.clientY - rect.top) / rect.height, 0, 1);
    const now = performance.now();
    point.speed = Math.hypot(x - lastX, y - lastY) / Math.max(0.016, (now - lastTime) / 1000);
    Object.assign(point, { x, y, active: true });
    lastX = x;
    lastY = y;
    lastTime = now;
  };
  element.addEventListener("pointermove", update);
  element.addEventListener("pointerenter", update);
  element.addEventListener("pointerleave", () => {
    point.active = false;
  });
  element.addEventListener("pointerdown", (event) => {
    update(event);
    point.down = true;
    element.setPointerCapture?.(event.pointerId);
  });
  element.addEventListener("pointerup", () => {
    point.down = false;
  });
  return point;
}

export function createLoop(draw, settings) {
  let frame = 0;
  let running = true;
  let last = performance.now();
  const tick = (now) => {
    if (!running) return;
    const dt = Math.min(0.04, (now - last) / 1000) * settings.speed;
    last = now;
    draw(dt, now / 1000, frame++);
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
  return () => {
    running = false;
  };
}

export function drawBird(ctx, x, y, scale = 1, angle = 0, color = "#17140f", openness = 0.45) {
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(angle);
  ctx.scale(scale, scale);
  ctx.strokeStyle = color;
  ctx.fillStyle = color;
  ctx.lineWidth = 1.2 / Math.max(0.5, scale);
  ctx.beginPath();
  ctx.moveTo(-8, 1);
  ctx.quadraticCurveTo(-3, -8 * openness, 0, 0);
  ctx.quadraticCurveTo(4, -9 * openness, 9, 1);
  ctx.quadraticCurveTo(4, -2, 0, 3);
  ctx.quadraticCurveTo(-4, -2, -8, 1);
  ctx.fill();
  ctx.restore();
}

export function createSvgElement(name, attrs = {}) {
  const element = document.createElementNS("http://www.w3.org/2000/svg", name);
  Object.entries(attrs).forEach(([key, value]) => element.setAttribute(key, value));
  return element;
}
